/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_RequiredInputs */

const ja_contact_form_required = /** @type {(inputs: Contact_Form_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(必須)`)
};

const en_contact_form_required = /** @type {(inputs: Contact_Form_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Required)`)
};

/**
* | output |
* | --- |
* | "(Required)" |
*
* @param {Contact_Form_RequiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_required = /** @type {((inputs?: Contact_Form_RequiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_RequiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_form_required(inputs)
	return en_contact_form_required(inputs)
});